// extracted by mini-css-extract-plugin
export var bottomRightDock = "_18-0";